export default "__VITE_ASSET__UNTD_aoR__"